import { render, staticRenderFns } from "./AlertDetails.vue?vue&type=template&id=7cf2cd52&scoped=true&"
import script from "./AlertDetails.vue?vue&type=script&lang=js&"
export * from "./AlertDetails.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetails.vue?vue&type=style&index=0&id=7cf2cd52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2cd52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VCol,VContainer,VDataTable,VForm,VIcon,VRow,VTextField,VTextarea})
